import { Drawer } from 'components/Drawer'
import { PropsWithChildren } from 'react'
import { MediaDrawerProps } from '../Types'
import Styles from './MediaDrawer.module.scss'

export const MediaDrawer = (props: PropsWithChildren<MediaDrawerProps>) => {
  const { title, children, ...rest } = props

  return (
    <Drawer.Root {...rest}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <div style={{ height: '100%' }} data-vaul-no-drag>
            <Drawer.InnerContent color="var(--light-100)" isSnappedTop>
              <Drawer.Top>
                <div />
                <Drawer.Title asChild>
                  <span className={Styles.title}>{title}</span>
                </Drawer.Title>
                <Drawer.Close label="Cancel" variant="ghost" position="right" />
                <Drawer.Description />
              </Drawer.Top>
              <Drawer.Container>{children}</Drawer.Container>
            </Drawer.InnerContent>
          </div>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
}
